// extracted by mini-css-extract-plugin
export const headBgColorExternal = "#ffffff";
export const headBgColorInternal = "#1c2234";
export const headBgColorShrunkSidebar = "#3c425a";
export const regular = "400";
export const medium = "500";
export const semibold = "600";
export const bold = "700";
export const sans = "'sans'";
export const serif = "'serif'";
export const atlasGrotesk = "'AtlasGrotesk'";
export const insightMediaMaxWidth = "640px";
export const media = "Media__media__Jh-mb";
export const ieFix = "Media__ieFix__uCim9";
export const image = "Media__image__+QNAd";
export const playIcon = "Media__playIcon__OoZwk";
export const spinnerContainer = "Media__spinnerContainer__7jHe-";
export const videoButton = "Media__videoButton__h0cLM";
export const isLoading = "Media__isLoading__crT9s";
export const video = "Media__video__1ZSt2";
export const videoThumbnail = "Media__videoThumbnail__fWNFY";
export const placeholder = "Media__placeholder__l7qSc";
export const hasGradient = "Media__hasGradient__0ML5C";